/**
 * Business-language error messages (spec 2 section 7): never surface raw
 * technical field/enum names to the user.
 */
const errorMessages = {
    pointsExceedMax: "Liczba punktów dla jednej z reguł przekracza maksymalną liczbę punktów tego kryterium.",
    rangeOverlap: "Zdefiniowane przedziały nakładają się na siebie — popraw zakresy przed zapisem.",
    aiMatchMissingCriterion: "Uzupełnij oczekiwaną odpowiedź / kryterium oceny AI przed zapisem.",
    aiMatchMissingLevels: "Dodaj co najmniej dwa poziomy zgodności z przypisaną punktacją.",
    duplicateCriterionKey: "To kryterium jest już uwzględnione w modelu oceny. Nie może zostać dodane ponownie.",
    lockedCriterionEdit: "To kryterium zostało zablokowane przez administratora scenariusza i nie może być tutaj zmienione.",
};

export default errorMessages;
